exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Hk2nXMg-Sidebar-module-sidebar{border:1px solid #ced4da;bottom:0;left:0;padding:48px 5px 5px;position:fixed;top:0;z-index:100}._3Vo4gnQ2-Sidebar-module-sidebar-sticky{height:calc(100vh - 48px);overflow-x:hidden;overflow-y:auto;padding-top:40px;position:-webkit-sticky;position:sticky;top:0}", ""]);

// exports
exports.locals = {
	"sidebar": "_3Hk2nXMg-Sidebar-module-sidebar",
	"sidebar-sticky": "_3Vo4gnQ2-Sidebar-module-sidebar-sticky",
	"sidebarSticky": "_3Vo4gnQ2-Sidebar-module-sidebar-sticky"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Sidebar/Sidebar.module.scss
// module id = 759
// module chunks = 0